(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);

  /*
   * Apply alphabetical A to Z sorting by default.
   * Visitors can still select another sorting option afterward.
   */
  if (!url.searchParams.has('sort_by')) {
    url.searchParams.set('sort_by', 'title-ascending');
    window.location.replace(url.toString());
  } else if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));

        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-by-finish"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('shop-by-finish-carousel')) {

  customElements.define(
    'shop-by-finish-carousel',

    class extends HTMLElement {

      connectedCallback() {

        /*
          Wait for Shopify to finish
          inserting the section.
        */

        this.setupFrame =
          requestAnimationFrame(
            () => this.setup()
          );

      }


      setup() {

        this.track =
          this.querySelector(
            '.shop-by-finish__grid'
          );


        this.controls =
          this.querySelector(
            '.shop-by-finish__controls'
          );


        if (
          !this.track ||
          !this.controls
        ) {
          return;
        }


        this.previous =
          this.querySelector(
            '[data-previous]'
          );


        this.next =
          this.querySelector(
            '[data-next]'
          );


        this.mobile =
          matchMedia(
            '(max-width: 749px)'
          );


        this.reducedMotion =
          matchMedia(
            '(prefers-reduced-motion: reduce)'
          );


        this.events =
          new AbortController();


        const options = {
          signal:
            this.events.signal
        };


        /* PREVIOUS */

        this.previous.addEventListener(
          'click',
          () => this.move(-1),
          options
        );


        /* NEXT */

        this.next.addEventListener(
          'click',
          () => this.move(1),
          options
        );


        /* SCROLL */

        this.track.addEventListener(
          'scroll',
          () => this.update(),
          {
            ...options,
            passive: true
          }
        );


        /* MOBILE CHANGE */

        this.mobile.addEventListener(
          'change',
          () => this.update(),
          options
        );


        /* KEYBOARD */

        this.track.addEventListener(
          'keydown',

          (event) => {

            if (
              !this.mobile.matches ||
              event.target !== this.track
            ) {
              return;
            }


            if (
              event.key !== 'ArrowLeft' &&
              event.key !== 'ArrowRight'
            ) {
              return;
            }


            event.preventDefault();


            const direction =
              event.key === 'ArrowRight'
              ? 1
              : -1;


            this.move(
              this.isRTL()
              ? -direction
              : direction
            );

          },

          options
        );


        /*
          Keep selected Shopify block
          visible in Theme Editor.
        */

        this.addEventListener(
          'shopify:block:select',

          (event) => {

            if (
              !this.mobile.matches
            ) {
              return;
            }


            const card =
              event.target.closest(
                '.shop-by-finish__card'
              );


            if (
              !card ||
              !this.track.contains(card)
            ) {
              return;
            }


            const trackRect =
              this.track
              .getBoundingClientRect();


            const cardRect =
              card
              .getBoundingClientRect();


            const offset =
              this.isRTL()
              ? cardRect.right - trackRect.right
              : cardRect.left - trackRect.left;


            this.track.scrollTo({

              left:
                this.track.scrollLeft
                +
                offset,

              behavior:
                'instant'

            });

          },

          options
        );


        /* RESIZE OBSERVER */

        this.observer =
          new ResizeObserver(
            () => this.update()
          );


        this.observer.observe(
          this.track
        );


        this.update();

      }


      /* =====================================================
         RTL CHECK
      ===================================================== */

      isRTL() {

        return (
          getComputedStyle(
            this.track
          ).direction
          ===
          'rtl'
        );

      }


      /* =====================================================
         MOVE CAROUSEL
      ===================================================== */

      move(direction) {

        if (
          !this.mobile.matches
        ) {
          return;
        }


        const card =
          this.track.querySelector(
            '.shop-by-finish__card'
          );


        if (
          !card
        ) {
          return;
        }


        const gap =
          parseFloat(
            getComputedStyle(
              this.track
            ).columnGap
          )
          ||
          0;


        const step =
          card
          .getBoundingClientRect()
          .width
          +
          gap;


        if (
          !step
        ) {
          return;
        }


        const maximum =
          Math.max(
            0,
            this.track.scrollWidth
            -
            this.track.clientWidth
          );


        const position =
          Math.abs(
            this.track.scrollLeft
          );


        const destination =
          Math.min(

            maximum,

            Math.max(

              0,

              (
                Math.round(
                  position
                  /
                  step
                )
                +
                direction
              )
              *
              step

            )

          );


        this.track.scrollTo({

          left:
            this.isRTL()
            ? -destination
            : destination,

          behavior:
            this.reducedMotion.matches
            ? 'instant'
            : 'smooth'

        });

      }


      /* =====================================================
         UPDATE CONTROLS
      ===================================================== */

      update() {

        const maximum =
          Math.max(

            0,

            this.track.scrollWidth
            -
            this.track.clientWidth

          );


        const position =
          Math.min(

            maximum,

            Math.max(

              0,

              Math.abs(
                this.track.scrollLeft
              )

            )

          );


        this.controls.hidden =
          !this.mobile.matches
          ||
          maximum <= 2;


        if (
          !this.controls.hidden
        ) {

          const image =
            this.track.querySelector(
              '.shop-by-finish__ring'
            );


          this.controls.style.top =
            `${
              (
                image
                ? image.offsetHeight
                : this.track.clientHeight
              )
              /
              2
            }px`;

        }


        this.controls.classList.toggle(
          'is-rtl',
          this.isRTL()
        );


        this.previous.disabled =
          position <= 2;


        this.next.disabled =
          position
          >=
          maximum - 2;

      }


      /* =====================================================
         CLEANUP
      ===================================================== */

      disconnectedCallback() {

        cancelAnimationFrame(
          this.setupFrame
        );


        if (
          this.events
        ) {

          this.events.abort();

        }


        if (
          this.observer
        ) {

          this.observer.disconnect();

        }

      }

    }

  );

}


  } catch(e) { console.error(e); }
})();
})();
